import { Util } from '@libs/utilities/util';

import { ISearchLinks, ISearchLinkUrlConfig } from '../../data/search-links.interface';


/**------------------------------------------------------
 * Google Search Url
 */
export class GoogleSearch implements ISearchLinks {

	//** Configurations */
	private readonly GOOGLE_CONFIG: ISearchLinkUrlConfig = {
		home		: 'https://www.google.com/',
		login		: 'https://accounts.google.com/signin/v2',
		search		: 'https://www.google.com//search?q=[SEARCH]'
	};


	//** Home & Login */
	home() : string { return this.GOOGLE_CONFIG.home; }
	login(): string { return this.GOOGLE_CONFIG.login; }

	//** Search */
	search(searchQuery: string): string {

		//0 - if no search string existing then return main or home page
		if (Util.String.isEmpty(searchQuery)) return this.home();

		//1 - else return the url with search query
		return this.GOOGLE_CONFIG.search.replace('[SEARCH]', searchQuery);
	}
}
